import { Link } from 'react-router-dom';
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function ContactCTA() {
  const { ref: ctaRef, isVisible: ctaVisible } = useScrollAnimation({ threshold: 0.3 });

  return (
    <section className="py-20 sm:py-32 lg:py-50 px-4 sm:px-6 bg-gradient-to-r from-navy to-navy-light relative overflow-hidden">
      {/* Animated Background Elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className={`absolute top-10 left-10 w-40 sm:w-64 h-40 sm:h-64 bg-white/5 rounded-full blur-3xl transition-all duration-1000 ${ctaVisible ? 'opacity-100 scale-100' : 'opacity-0 scale-50'}`}></div>
        <div className={`absolute bottom-10 right-10 w-60 sm:w-96 h-60 sm:h-96 bg-slate-blue/10 rounded-full blur-3xl transition-all duration-1000 delay-300 ${ctaVisible ? 'opacity-100 scale-100' : 'opacity-0 scale-50'}`}></div>
      </div>

      <div ref={ctaRef} className="max-w-5xl mx-auto text-center relative z-10">
        <h2
          className={`text-white text-[26px] sm:text-[36px] lg:text-[44px] font-semibold mb-4 sm:mb-5 leading-tight transition-all duration-700 ease-out ${
            ctaVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          Ready to Lease Imaging Equipment?
        </h2>
        <p
          className={`text-white/85 text-base sm:text-lg mb-8 sm:mb-12 transition-all duration-700 ease-out delay-150 ${
            ctaVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          Speak with our leasing team about equipment availability, contract terms, and deployment timelines.
        </p>

        <Link
          to="/contact"
          className={`inline-flex items-center gap-3 sm:gap-4 bg-white text-navy px-8 sm:px-14 py-4 sm:py-5 rounded-full text-base sm:text-lg font-semibold hover:shadow-2xl transition-all duration-500 cursor-pointer group hover:scale-105 ${
            ctaVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
          style={{ transitionDelay: ctaVisible ? '300ms' : '0ms' }}
        >
          <div className="w-8 h-8 sm:w-10 sm:h-10 bg-accent-orange rounded-full flex items-center justify-center transition-all duration-300 group-hover:scale-110 group-hover:rotate-12">
            <i className="ri-mail-line text-white text-lg sm:text-xl"></i>
          </div>
          <span className="whitespace-nowrap">Request a Lease Quote</span>
          <i className="ri-arrow-right-up-line text-navy text-lg sm:text-xl transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1"></i>
        </Link>

        {/* Trust Indicators */}
        <div
          className={`flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8 mt-8 sm:mt-12 transition-all duration-700 ease-out delay-500 ${
            ctaVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <div className="flex items-center gap-2 text-white/70">
            <i className="ri-time-line text-lg"></i>
            <span className="text-sm">24hr Response</span>
          </div>
          <div className="w-px h-4 bg-white/30 hidden sm:block"></div>
          <div className="flex items-center gap-2 text-white/70">
            <i className="ri-truck-line text-lg"></i>
            <span className="text-sm">48–72hr Deployment</span>
          </div>
          <div className="w-px h-4 bg-white/30 hidden sm:block"></div>
          <div className="flex items-center gap-2 text-white/70">
            <i className="ri-file-list-3-line text-lg"></i>
            <span className="text-sm">Flexible Lease Terms</span>
          </div>
        </div>
      </div>
    </section>
  );
}
